import React from 'react';
import { Fade } from '@mui/material';
import { Stack } from '../../../stack';
import { Box } from '../../../box';
import { Typography } from '../../../typography';
import { useTheme } from '../../../../hooks';
import { ArrowRightIcon } from '../../../../icons';
import { InstructionProps } from './types';
import { Pointer } from './components/pointer';

const CIRCLE_SIZE = 36;

export const Instruction: React.FC<InstructionProps> = ({ onCompleted }) => {
  const theme = useTheme();
  const [isActive, setActive] = React.useState(true);

  const handleClick = () => {
    setActive(false);
  };

  const renderPart = (position: 'left' | 'right') => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          flex: '0 0 50%',
          borderLeft: position === 'right' ? `1px dashed ${theme.palette.white}` : undefined,
        }}
      >
        <Box
          sx={{
            width: CIRCLE_SIZE,
            height: CIRCLE_SIZE,
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            position: 'relative',
          }}
        >
          <Pointer
            style={{
              position: 'absolute',
              top: 10,
              left: position === 'right' ? 10 : 'auto',
              right: position === 'right' ? 'auto' : 10,
              transform: position === 'right' ? undefined : 'rotate(90deg)',
            }}
          />
        </Box>
        <ArrowRightIcon
          fontSize="3rem"
          sx={{ mt: 2, mb: -1, transform: position === 'left' ? 'rotate(180deg)' : undefined, color: theme.palette.white }}
        />
        <Typography sx={{ color: theme.palette.white }} variant="button">
          {position === 'left' ? 'DISLIKE' : 'LIKE'}
        </Typography>
      </Box>
    );
  };

  return (
    <Fade in={isActive} onExited={onCompleted} unmountOnExit>
      <Stack
        direction="row"
        onClick={handleClick}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 3,
          background: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(8px)',
        }}
      >
        {renderPart('left')}
        {renderPart('right')}
      </Stack>
    </Fade>
  );
};
